import { css } from "styled-system/css";

/** Shared sizing for profile and server badge collections. */
export const badgeItem = css({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "22px",
  height: "22px",
  flexShrink: 0,
  borderRadius: "3px",
  color: "var(--z-icon-color, var(--z-fg-primary))",
  background: "transparent",
  border: "none",
  "& > svg": { width: "20px", height: "20px", display: "block", flexShrink: 0 },
  _hover: { filter: "brightness(1.15)" },
  _focusVisible: { outline: "2px solid var(--z-focus)", outlineOffset: "2px" },
});

export const badgeGroup = css({
  display: "flex",
  direction: "rtl",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "flex-start",
  alignSelf: "flex-end",
  gap: "5px",
  width: "fit-content",
  maxWidth: "100%",
  minWidth: 0,
});
